import React from 'react';
import PropTypes from 'prop-types';
import Admin from 'components/layout/Admin/Admin';
import Casengo from 'containers/Casengo/Casengo';
import LoadingScreen from 'pages/LoadingScreen';
import Raven from 'raven-js';
import config from 'helpers/config';
import environmentHelper from 'helpers/environment';
import { fetchAndSetDefaultAccount } from 'services/auth';
import { clearToken } from 'http/clientToken';
import { configRequest } from 'http/requests/configRequests';
import { reloginRequest } from 'http/requests/authRequests';

class App extends React.Component {
    constructor() {
        super();

        this.state = {
            configuration: null,
        };
    }

    getChildContext() {
        const {
            configuration,
        } = this.state;

        return {
            config: configuration,
        };
    }

    componentDidMount() {
        let configuration;

        // Fetch the configuration
        configRequest().then(function (response) {
            configuration = response;

            // Fetch a current session if available
            return reloginRequest().then(function (profile) {

                // Fetch a current account if available
                return fetchAndSetDefaultAccount(profile);
            });
        }).catch(() => {
            // Inactive session
            clearToken();

            // Removing the user context from raven.
            Raven.setUserContext();
        }).then(() => {
            this.setState({
                configuration: configuration,
            });
        });

        // Let's initialise the Google Analytics tool
        if (config.getGoogleAnaltyicsTrackingId() && environmentHelper.resolveEnvironment() !== environmentHelper.ENV_LOCAL) {
            if (!window.ga) {
                return;
            }

            window.ga('create', config.getGoogleAnaltyicsTrackingId(), 'auto');
        }
    }

    render() {
        const {
            configuration,
        } = this.state;

        if (!configuration) {
            return <LoadingScreen />;
        }

        return (
            <div>
                <Admin
                    configuration={ configuration }
                />

                { (environmentHelper.resolveEnvironment() !== environmentHelper.ENV_LOCAL) &&
                    <Casengo />
                }
            </div>
        );
    }
}

App.childContextTypes = {
    config: PropTypes.object,
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js